import { type IStoreState } from "@/vue/planning/store/state/state"
import { WiypResponse } from "@/types/responses"

export default {
	wiypCall: (state: IStoreState): Record<string, Record<string, WiypResponse>> => {
		return state.wiypCall;
	},
	getWiypCallByFamilyComposition: (state: IStoreState) => (familyComposition: string): Record<string, WiypResponse> | undefined => {
		return state.wiypCall[familyComposition];
	},
	getWiypCallByFamilyCompositionAndOriginAndPackageCode: (state: IStoreState) => (familyComposition: string, origin: string, packageCode: string): Record<string, WiypResponse> | undefined => {
		return state.wiypCall[familyComposition]?.[origin]?.[packageCode];
	},
	getWiypCallByFamilyCompositionAndOriginAndPackageCodeAndId: (state: IStoreState) => (familyComposition: string, origin: string, packageCode: string, packageId: string): WiypResponse | undefined => {
		return state.wiypCall[familyComposition]?.[origin]?.[packageCode]?.[packageId];
	},

	// To remove
	// getWiypCallByFamilyCompositionAndPackageCode: (state: IStoreState) => (familyComposition: string, packageCode: string): Record<string, WiypResponse> | undefined => {
	// 	return state.wiypCall[familyComposition][packageCode];
	// },
	// getWiypCallByFamilyCompositionAndPackageCodeAndId: (state: IStoreState) => (familyComposition: string, packageCode: string, packageId: string): WiypResponse | undefined => {
	// 	return state.wiypCall[familyComposition]?.[packageCode]?.[packageId];
	// },
}

